<main class="container">

  <div class="starter-template text-center py-5 px-3">
    <h1>Кажется что-то пошло не так</h1>
    <p class="lead">Возможно в адресе страницы допущена ошибка</p>
  </div>

</main>
